import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import styles from './HomePage.module.css';

const HomePage = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div className={styles.homePage}>
      <div className="container">
        <div className={styles.hero}>

          <p className={styles.subtitle}>
            Sicheres One-Time-Secret Sharing für den täglichen Gebrauch
          </p>
          <p className={styles.description}>
            Teile sensible Informationen wie Passwörter, API-Schlüssel oder
            Credentials sicher mit automatischer Zerstörung nach
            Zugriff.
          </p>

          {/* DISPLAY authentication status and available features */}
          {!isAuthenticated && (
            <div className={styles.anonymousNotice}>
              <h3>Anonymer Modus</h3>
              <p>
                Du nutzt den anonymen Modus mit begrenzten Funktionen.
                Secrets bleiben maximal 1 Stunde verfügbar.
              </p>
            </div>
          )}

          <div className={styles.actions}>
            <Link to="/create" className="btn btn-primary">
              Neues Secret erstellen
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;